import React from 'react';

import { FormProvider, useForm } from 'react-hook-form';
import { observer } from 'mobx-react';

import { LbModal } from '../../../../../shared/components/modals';
import { ModalInputs } from './ModalInputs/ModalInputs';
import { apiStatusStore } from '../../../../../shared/stores/apiStatusStore';
import { salesReportStore } from '../../../../stores/salesReportStore';
import { DownloadParams } from '../../../../interfaces/DownloadParams';

const DownloadReportModal = observer(() => {
  const { isLoading } = apiStatusStore;
  const { selectedReport, isShowDownloadModal, closeDownloadModal, downloadReport } =
    salesReportStore;

  const methods = useForm<DownloadParams>();
  const { handleSubmit } = methods;

  if (!selectedReport) return null;

  const { reportType, title, settings } = selectedReport;

  return (
    <FormProvider {...methods}>
      <LbModal
        open={isShowDownloadModal}
        title={`"${title}" Report`}
        isLoading={isLoading}
        primaryBtnConfig={{ text: 'Download', onClick: handleSubmit(downloadReport) }}
        secondaryBtnConfig={{ onClick: closeDownloadModal }}
      >
        <ModalInputs selectorsSettings={settings} reportType={reportType} />
      </LbModal>
    </FormProvider>
  );
});

export { DownloadReportModal };
